import { loadState } from '@/store'
import { getStateProfile } from '@/store/getters'
import { getAuth0Header } from '@/services/tokenManager'
import { identifyUserInTracking } from '@/services/tracking'
import { syncCookieConsent } from '@/services/cookies'
import { translationProvider } from '@/services/translationProvider'
import { checkUserTermsOrConsentAndRedirect } from '@/components/modal-manager'

// Re-entrancy guard: loadState() calls significant state mutations that can
// trigger watchers, which in turn can call loadUserData again.
// This guard prevents multiple simultaneous executions of loadState.
let _loading = false

export const loadUserData = async (onLogin = false) => {
  if (_loading) return

  _loading = true

  try {
    const authHeader = await getAuth0Header()
    if (!authHeader) {
      console.warn('[orcas-shell - userDataHelper] - Undefined auth header')
      return
    }

    if (!(await loadState())) {
      return
    }

    await Promise.all([
      translationProvider.set(getStateProfile().language),
      identifyUserInTracking(onLogin),
    ])

    // sync consent in background
    syncCookieConsent()

    // On startup bootstrap runs this check once the feature flags are loaded too
    if (onLogin) {
      checkUserTermsOrConsentAndRedirect()
    }
  } finally {
    _loading = false
  }
}
